var voted_users_default = {
  "container": "Dncus",
  "webview": "wRVrZ",
  "avatar_list": "KQyuP",
  "avatar": "BcTwh",
  "user_avatar": "AjLmg",
  "modal": "dgsc6",
  "voted_users_modal": "rno-T",
  "overlay": "WQ3Jj",
  "user_card": "T3-rt",
  "user_name": "_9aRtl",
  "voted_users_modal_header": "A89DP",
  "cta": "yJUn-",
  "close_icon": "rxH0G",
  "title": "Mfmc0",
  "member_list_container": "rfU5k",
  "member_list": "CdTsy",
  "loader": "_9Inuj",
  "anonymous_counter": "ehRMK",
  "spinner": "J0yZI",
  "spin": "LDD-o"
};
export {
  voted_users_default as default
};
//# sourceMappingURL=voted-users-scss.js.map
